export enum LifeCycle {
    Active = 0,
    Delete = 1,
    Deleted = 2,
    Archive = 3,
    Archived = 4,
    Creation = 5,
    Requested = 6,
}

export const LifeCycleLabel: Record<LifeCycle, string> = {
  [LifeCycle.Active]: 'Active',
  [LifeCycle.Delete]: 'Delete',
  [LifeCycle.Deleted]: 'Deleted',
  [LifeCycle.Archive]: 'Archive',
  [LifeCycle.Archived]: 'Archived',
  [LifeCycle.Creation]: 'Creation',
  [LifeCycle.Requested]: 'Requested',
};

enum TeamActivityState {
    Active = "Active",
    Inactive = "Inactive",
}

export enum TeamActionState {
    TeamActive = 0,
    TeamNotification2Month = 1,
    TeamNotification1Month = 2,
    TeamNotification5Day = 3,
    TeamNotificationDelete = 4,
}

export const TeamActionStateLabel: Record<TeamActionState, string> = {
  [TeamActionState.TeamActive]: 'Active',
  [TeamActionState.TeamNotification2Month]: '2 Months',
  [TeamActionState.TeamNotification1Month]: '1 Month',
  [TeamActionState.TeamNotification5Day]: '5 Days',
  [TeamActionState.TeamNotificationDelete]: 'Delete',
};

interface ActionStateDate {
    date: string;
    state: TeamActionState;
}

export interface MyTeamLifeCycle {
    id: string;
    createdDateTime: string;
    changedDateTime: string;
    usn: number;
    myTeamId: string;
    myTeamM365Id: string;
    myTeamName: string;
    myTeamLifeCycleState: LifeCycle;
    myTeamCategoryId: string;
    myTeamLifeCycleDateTime?: string;
    myTeamCreatedDateTime?: string;
    myTeamDeletedDateTime?: string;
    activityState?: TeamActivityState;
    actionState?: TeamActionState;
    newActionState?: TeamActionState;
    actionStateHistory?: ActionStateDate[];
    nextActionDate?: string;
    expectedEndOfLife?: string;
    lastTeamActivity?: string;
    lastTeamMessageDateTime?: string;
    lastTeamFileDateTime?: string;
    lastCheckUpDate?: string;
    documentType?: string;
}